<template>
    <div class="tab-body">
        <div class="rigth-panel-header"></div>
        <div class="rigth-panel-body">
            <div class="right-panel-section-header">
                <div class="right-panel-section-header-title">Web domain registration</div>
                <div class="right-panel-section-header-option">
                    <b-button type="is-primary" size="is-small" :loading="configDomainLoading"
                        @click="configDomain()">Configure domain</b-button>
                    <div class="h-spacer"></div>
                    <b-button type="is-default" size="is-small" :loading="removeDomainConfigLoading"
                        @click="removeDomainConfig()">Remove domain config</b-button>
                </div>
            </div>
            <div class="right-panel-section-body">
                <b-tag v-if="!user.hasDomain" type="is-warning">Domain not set</b-tag>
                <b-tag v-if="user.hasDomain && user.domainRegistrationStatus == 'completed'" type="is-success">Domain was
                    registred</b-tag>
            </div>
            <div class="right-panel-section-header">
                <div class="right-panel-section-header-title">Web domain SSL certificate</div>
                <div class="right-panel-section-header-option">
                    <b-button type="is-primary" size="is-small" :loading="configDomainSSLLoading"
                        @click="configDomainSSL()">Configure SSL</b-button>
                </div>
            </div>
            <div class="right-panel-section-body">
                <b-tag type="is-danger" v-if="!user.hasDomain">Domain SSL not set</b-tag>
                <b-tag type="is-warning"
                    v-if="user.hasDomain && user.domainSslStatus == 'phase_1_pending' || user.hasDomain && user.domainSslStatus == 'phase_2_pending'">Domain
                    SSL Pending</b-tag>
                <b-tag type="is-success" v-if="user.hasDomain && user.domainSslStatus == 'completed'">Domain
                    SSL was set successfuly</b-tag>
            </div>
            <div class="right-panel-section-header">
                <div class="right-panel-section-header-title">Show content on <b>watch.rw</b></div>
                <div class="right-panel-section-header-option">
                    <b-loading :is-full-page="false" v-model="showOnOriginalSiteLoading" :can-cancel="false"></b-loading>
                    <b-switch v-model="isShowOnOriginalSiteSwitched" true-value="Yes" false-value="No" @input="showContent">
                        {{ isShowOnOriginalSiteSwitched }}
                    </b-switch>
                </div>
            </div>
        </div>
        <div class="rigth-panel-footer"></div>
    </div>
</template>
<script>
export default {
    components: {},
    props: {
        user: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        configDomainLoading: false,
        removeDomainConfigLoading: false,
        configDomainSSLLoading: false,
        showOnOriginalSiteLoading: false
    }),
    computed: {
        isShowOnOriginalSiteSwitched() {
            let vm = this;
            return vm.user.showOnOriginalWebsite ? 'Yes' : 'No';
        }
    },
    watch: {},
    mounted() {

    },
    methods: {
        configDomain() {
            let vm = this;
            vm.configDomainLoading = true;
            vm.$store
                .dispatch("ADMIN_USER_REGISTER_WEB_DOMAIN", {
                    user_id: vm.user.id,
                    domain: vm.user.domain,
                    adminDomain: 'admin.' + vm.user.domain
                })
                .then((response) => {
                    vm.configDomainLoading = false;
                    vm.$buefy.toast.open({
                        message: response.data.message,
                        type: "is-success",
                    });
                })
                .catch(({ response }) => {
                    vm.configDomainLoading = false;
                    vm.$buefy.toast.open({
                        message: response.data.message,
                        type: "is-danger",
                    });
                });
        },
        removeDomainConfig() {
            let vm = this;
            this.$buefy.dialog.confirm({
                title: 'Deleting account',
                message: `Are you sure you want to delete <b> ${vm.user.domain}</b>  config? This action cannot be undone.`,
                confirmText: 'Delete Config',
                type: 'is-danger',
                hasIcon: true,
                onConfirm: () => {
                    vm.removeDomainConfigLoading = true;
                    vm.$store
                        .dispatch("ADMIN_USER_REMOVE_WEB_DOMAIN_CONFIG", {
                            user_id: vm.user.id,
                            domain: vm.user.domain,
                            adminDomain: 'admin.' + vm.user.domain
                        })
                        .then((response) => {
                            vm.removeDomainConfigLoading = false;
                            vm.$buefy.toast.open({
                                message: response.data.message,
                                type: "is-success",
                            });
                        })
                        .catch(({ response }) => {
                            vm.removeDomainConfigLoading = false;
                            vm.$buefy.toast.open({
                                message: response.data.message,
                                type: "is-danger",
                            });
                        });
                }
            });
        },
        configDomainSSL() {
            let vm = this;
            vm.configDomainSSLLoading = true;
            vm.$store
                .dispatch("ADMIN_USER_CONFIG_WEB_SSL", {
                    user_id: vm.user.id,
                    domain: vm.user.domain,
                    adminDomain: 'admin.' + vm.user.domain
                })
                .then((response) => {
                    vm.configDomainSSLLoading = false;
                    vm.$buefy.toast.open({
                        message: response.data.message,
                        type: "is-success",
                    });
                })
                .catch(({ response }) => {
                    vm.configDomainSSLLoading = false;
                    vm.$buefy.toast.open({
                        message: response.data.message,
                        type: "is-danger",
                    });
                });
        },
        showContent(status) {
            let vm = this;
            const payload = {
                user_id: vm.user.id,
                showContent: status == 'Yes' ? true : false
            }
            vm.showOnOriginalSiteLoading = true;
            vm.$store
                .dispatch("ADMIN_USER_SHOW_CONTENT_ON_ORIGINAL_SITE", payload)
                .then((response) => {
                    vm.showOnOriginalSiteLoading = false;
                    vm.$buefy.toast.open({
                        message: response.data.message,
                        type: "is-success",
                    });
                })
                .catch(({ response }) => {
                    vm.showOnOriginalSiteLoading = false;
                    vm.$buefy.toast.open({
                        message: response.data.message,
                        type: "is-danger",
                    });
                });
        }
    },
};
</script>
<style lang="scss" scoped>
.tab-body {
    height: calc(100% - 55px);
    display: flex;
    flex-direction: column;
    position: relative;

    .rigth-panel-header {
        height: 0px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #ddd;
        padding: 0px 10px;
    }

    .rigth-panel-body {
        overflow-y: auto;
        height: calc(100% - 0px);

        .right-panel-section-header {
            background-color: #fff;
            padding: 0px 10px;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #ddd;

            .right-panel-section-header-title {
                font-size: 16px;
                font-weight: 500;
            }

            .right-panel-section-header-option {
                display: flex;
            }
        }

        .right-panel-section-body {
            padding: 10px;
        }

        .permission-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 0px;

            .permission-item-name {
                font-size: 14px;
                font-weight: 500;
            }

            .permission-item-option {
                display: flex;
                align-items: center;
                justify-content: flex-end;
            }
        }
    }

    .rigth-panel-footer {
        height: 0px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-top: 1px solid #ddd;
    }
}
</style>